import { useMemo } from "react";

/**
 * Days until the same reference date the desk uses for urgency (`getDaysUntilSellBy` in ExpiryDeskApp):
 * sell-by = last calendar day of the month *before* the printed expiry month; if `expiryDate` is set, that calendar date is used.
 */
function daysUntilDeskExpiryReference(med) {
  const today = new Date();
  if (med?.expiryDate) {
    const t = new Date(med.expiryDate);
    if (Number.isNaN(t.getTime())) return Number.NaN;
    return Math.ceil((t.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  }
  const m = Number(med?.expiryMonth);
  const y = Number(med?.expiryYear);
  if (!Number.isFinite(m) || !Number.isFinite(y)) return Number.NaN;
  const sellBy = new Date(y, m - 1, 0);
  return Math.ceil((sellBy.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

export function useExpirySummary(medications) {
  return useMemo(() => {
    const active = (medications || []).filter((med) => med?.status !== "item_expired" && med?.status !== "item_moved");
    const expired = active.filter((med) => {
      const days = daysUntilDeskExpiryReference(med);
      return Number.isFinite(days) && days < 0;
    });
    const expiringThisWeek = active.filter((med) => {
      const days = daysUntilDeskExpiryReference(med);
      return Number.isFinite(days) && days >= 0 && days <= 7;
    });
    const expiringSoon = active.filter((med) => {
      const days = daysUntilDeskExpiryReference(med);
      return Number.isFinite(days) && days >= 0 && days <= 30;
    });

    return {
      expired,
      expiringThisWeek,
      expiringSoon,
      expiredCount: expired.length,
      expiringThisWeekCount: expiringThisWeek.length,
      expiringSoonCount: expiringSoon.length,
      totalAtRisk: expired.length + expiringThisWeek.length,
    };
  }, [medications]);
}
